import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/app/admin/accounting/")({
  beforeLoad: () => {
    throw redirect({ to: "/app/admin/accounting/accounts-chart" })
  },
})
